import * as SliderPrimitive from '@radix-ui/react-slider';
import type { FC } from 'react';

type TimeDurationSliderProps = {
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
  className?: string;
};

const TimeDurationSlider: FC<TimeDurationSliderProps> = ({
  value,
  min = 3,
  max = 12,
  step = 1,
  onChange,
  className = '',
}) => {
  return (
    <SliderPrimitive.Root
      min={min}
      max={max}
      step={step}
      value={[value]}
      onValueChange={([v]) => onChange(v)}
      className={`relative flex w-full items-center py-2 ${className}`}
    >
      <SliderPrimitive.Track className="relative h-[3px] w-full rounded-full bg-gray-300">
        <SliderPrimitive.Range className="absolute h-full rounded-full bg-[#1F1F1F]" />
      </SliderPrimitive.Track>

      <SliderPrimitive.Thumb className="block h-4 w-4 rounded-full border border-[#C4C7CC] bg-white shadow-sm outline-none focus-visible:ring-2 focus-visible:ring-[#00B5C9] focus-visible:ring-offset-0" />
    </SliderPrimitive.Root>
  );
};

export default TimeDurationSlider;
